import API from "./lib/api";

export const getAllBuyGetItemOffersApi = async (restaurant_id, query = "") => {
  try {
    const { data } = await API.get(
      `restaurant/${restaurant_id}/buy-and-get-free-item-offers?${query}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleBuyGetItemOfferApi = async (id) => {
  try {
    const { data } = await API.get(
      `restaurant/buy-and-get-free-item-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const addBuyGetItemOfferApi = async (offerData) => {
  try {
    const { data } = await API.post(
      `restaurant/buy-and-get-free-item-offers`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const editBuyGetItemOfferApi = async (offerData, id) => {
  try {
    const { data } = await API.put(
      `restaurant/buy-and-get-free-item-offers/${id}`,
      offerData
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteBuyGetItemOfferApi = async (id) => {
  try {
    const { data } = await API.delete(
      `restaurant/buy-and-get-free-item-offers/${id}`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleBuyGetItemOfferStatusApi = async (id) => {
  try {
    const { data } = await API.put(
      `restaurant/buy-and-get-free-item-offers/${id}/toggle-status`
    );
    return data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
